var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubspotCircleSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.674,
    height: 26.879,
    viewBox: "0 0 25.674 26.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hubspot",
    transform: "translate(-338.993 -704.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hubspot-1",
    d: "M29.375,12.959v-3.2A2.465,2.465,0,0,0,30.8,7.537V7.463A2.465,2.465,0,0,0,28.332,5h-.074a2.465,2.465,0,0,0-2.465,2.465v.073a2.465,2.465,0,0,0,1.421,2.222v3.2A6.98,6.98,0,0,0,23.9,14.42L15.117,7.583A2.806,2.806,0,1,0,13.8,9.291l8.644,6.726a7,7,0,0,0,.107,7.886l-2.629,2.63a2.325,2.325,0,1,0,1.518,1.518l2.6-2.6a7.013,7.013,0,1,0,5.331-12.491M28.3,23.486a3.6,3.6,0,1,1,3.472-3.6,3.6,3.6,0,0,1-3.472,3.6",
    transform: "translate(329.331 699.941)",
    fill: "#ff7a59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspotCircleSmallIcon);
export default __webpack_public_path__ + "static/media/hubspot-circle-small-icon.3dd55765200dd42fd6993a48b4f0a24b.svg";
export { ForwardRef as ReactComponent };